// extracted by mini-css-extract-plugin
module.exports = {"button":"FJPrimaryButton_button__2WMMD","disabled":"FJPrimaryButton_disabled__3s5ZH","button_text":"FJPrimaryButton_button_text__22RM5"};